import { render, staticRenderFns } from "./regimestributarios.vue?vue&type=template&id=494ef79b&scoped=true&"
import script from "./regimestributarios.vue?vue&type=script&lang=js&"
export * from "./regimestributarios.vue?vue&type=script&lang=js&"
import style0 from "./regimestributarios.vue?vue&type=style&index=0&id=494ef79b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ef79b",
  null
  
)

export default component.exports